module.exports = __webpack_public_path__ + "static/media/Jihlava.86630ef1.jpg";